import React from 'react';

import loadingLogo from 'assets/images/loading.gif';
import './Spinner.scss';
import { ReturnComponentType } from 'common';

export const Spinner = (): ReturnComponentType => {
  return <img className="Spinner small" src={loadingLogo} alt="loading-logo" />;
};
